import React, { useState, useEffect, useRef } from "react";
import "../styles/home.css";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import Testimonials from "../components/Testimonial/Testimonials";
import Slider from "react-slick"; // Thêm react-slick
import { useTranslation } from "react-i18next";

import ganafarm from "../assets/images/ganafarm.png";
import mekongCocoa from "../assets/images/mekongCocoa.png";
import mekong from "../assets/images/mekong.png";
import henk from "../assets/images/henkChocolate.png";
import markandmilk from "../assets/images/markandmilk.png";
import logoHenk from "../assets/images/logoHenk.png";
import logoGanafarm from "../assets/images/logoGanafarm.png";
import logoMekongcocoa from "../assets/images/logoMekongcocoa.png";
import logoMarkandmilk from "../assets/images/logoMarkandmilk.png";
import imgTextPackingMobile from "../assets/images/imgTextPackingMekongMobile.png";
import imgTextPacking from "../assets/images/imgTextPackingMekong.png";

// Cấu hình slider cho mobile
const sliderSettings = {
  infinite: true,
  autoplay: true,
  speed: 2000,
  swipeToSlide: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  arrows: true,
  dots: true,
  responsive: [
    {
      breakpoint: 1399,
      settings: { slidesToShow: 3, slidesToScroll: 1 },
    },
    {
      breakpoint: 1023,
      settings: { slidesToShow: 2, slidesToScroll: 2 },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

const listCategory = [
  {
    name: "HENK CHOCOLATE",
    title: "EVERY PIECE IS A PRESENT",
    image: henk,
    dotColor: "#f8ae42",
    link: "/san-pham/henk",
    desc: "desc_henk",
  },
  {
    name: "MARKANDMILK",
    title: "PICK ME UP",
    image: markandmilk,
    dotColor: "#be2735",
    link: "/san-pham/mark-and-milk",
    desc: "desc_markandmilk",
  },
  {
    name: "GANAFARM",
    title: "CREATING JOY",
    image: ganafarm,
    dotColor: "#593535",
    link: "/san-pham/ganafarm",
    desc: "desc_ganafarm",
  },
  {
    name: "MEKONG COCOA",
    title: "AUTHENTIC CHOCOLATE",
    image: mekongCocoa,
    dotColor: "#000000",
    link: "/san-pham/mekong-cocoa",
    desc: "desc_mekongcocoa",
  },
];

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1399);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 899);
  const { t, i18n } = useTranslation(); // Thêm useTranslation

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1399);
      setIsTablet(window.innerWidth <= 899);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="home-page">
      <section className="home__banner">
        <Testimonials />
      </section>

      <section>
        <div
          style={{
            paddingLeft: "0",
            paddingRight: "0",
            background: "#231F20",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Row className="about_mekong container">
            <Col className="about_mekong_img">
              <img src={mekong} alt="" />
            </Col>
            <Col className="about_mekong_content">
              {i18n.language === "en" ? (
                <h2>{t("package_vietnamese_heart")}</h2>
              ) : isTablet ? (
                <img src={imgTextPackingMobile} alt="" />
              ) : (
                <img src={imgTextPacking} alt="" />
              )}
              <p>{t("about_mekong_desc")}</p>
              <Link to="/gioi-thieu" style={{ color: "#1d1d1b" }}>
                <button style={{ color: "#1d1d1b" }}>{t("read_more")}</button>
              </Link>
            </Col>
          </Row>
        </div>
      </section>

      <section>
        <div className="present_product container">
          <Row className="content__title">
            <h2 className="title">{t("every_piece_is_a_present")}</h2>
            <p>{t("present_product_desc1")}</p>
            <p>{t("present_product_desc2")}</p>
          </Row>
          <Row className="list_category">
            {isMobile ? (
              <Slider {...sliderSettings}>
                {listCategory.map((item, index) => (
                  <div className="category" key={index}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{ backgroundColor: "#000" }}
                    />
                    <div
                      className="card-dot"
                      style={{ backgroundColor: item.dotColor }}
                    ></div>
                    <div className="desc">
                      <h5>{item.name}</h5>
                      <h4>{t(item.title.toLowerCase().replace(/ /g, "_"))}</h4>
                      <p>{t(item.desc)}</p>
                      <a href={item.link} style={{ fontWeight: "bold" }}>
                        {t("see_more")}
                      </a>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <>
                {listCategory.map((item, index) => (
                  <Col lg="3" className="category" key={index}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{ backgroundColor: "#000" }}
                    />
                    <div
                      className="card-dot"
                      style={{ backgroundColor: item.dotColor }}
                    ></div>
                    <div className="desc">
                      <h5>{item.name}</h5>
                      <h4>{t(item.title.toLowerCase().replace(/ /g, "_"))}</h4>
                      <p>{t(item.desc)}</p>
                      <a href={item.link} style={{ fontWeight: "bold" }}>
                        {t("see_more")}
                      </a>
                    </div>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </div>
      </section>
      <section>
        <div className="brand-logos">
          <img src={logoHenk} alt={t("henk")} />
          <img src={logoMarkandmilk} alt={t("mark_and_milk")} />
          <img src={logoMekongcocoa} alt={t("mekong_cocoa")} />
          <img src={logoGanafarm} alt={t("ganafarm")} />
        </div>
      </section>
    </div>
  );
};

export default Home;
